// import "./App.css";
import Home from "./pages/Home/Home";
import Login from "./pages/Login/Login";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import {API_URL} from "./consts";

function App() {
    const [user, setUser] = useState(null);

    useEffect(() => {
        const getUser = async () => {
            const res = await fetch(`${process.env.REACT_APP_API_ROOT}/api/user/getUser`, {
                credentials: "include",
            });
            const user = await res.json()
            console.log(user);
            if(res.status === 200) {
                setUser(user)
            }
        }

        getUser();
    }, []);

    return (
        <div className="App">
            <Router>
                <Routes>
                    {
                        !user
                            ? <Route path="/" element={<Login />} />
                            : <Route path="/home" element={<Home />} />
                        
                    }
                </Routes>
            </Router>
        </div>
    );
}

export default App;
